import { Component, Inject, OnInit } from "@angular/core"
import { NgForm } from "@angular/forms"
import { MD_DIALOG_DATA, MdDialog, MdDialogRef } from "@angular/material"

import { Merchant } from "../../../shared/merchant"
import { MerchantReferralCampaignPagesColors } from "../../../shared/merchant-referral"
import { ToolService } from "../../../tool.service"
import { AdvocateInfo } from "../../advocate-info"
import { ReferralService } from "../../referral.service"
import { ModalData } from "../modal-data"
import { ReferralMagicSuccessModalComponent } from "../success-modal/success-modal.component"

@Component({
  selector: "app-email-modal",
  templateUrl: "./email-modal.component.html",
  styleUrls: ["./email-modal.component.scss"],
  providers: [ReferralService, ToolService]
})
export class ReferralMagicEmailModalComponent implements OnInit {
  // Local variables
  advocate_info: AdvocateInfo
  advocate_identifier: string
  advocate_url: string
  colors: MerchantReferralCampaignPagesColors
  error: string
  merchant: Merchant
  qualification: string
  is_embedded: boolean
  is_submitted = false
  model = {
    email: "",
    subject: "",
    message: ""
  }
  patterns: any = {
    email:
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/
  }

  constructor(
    private referralService: ReferralService,
    private mdDialog: MdDialog,
    private mdDialogRef: MdDialogRef<ReferralMagicEmailModalComponent>,
    @Inject(MD_DIALOG_DATA) public data: ModalData
  ) {
    this.advocate_info = data.advocate_info
    this.advocate_identifier = data.advocate_identifier
    this.advocate_url = data.advocate_url
    this.colors = data.colors
    this.is_embedded = data.is_embedded
    this.merchant = data.merchant
    this.qualification = data.qualification
  }

  ngOnInit() {
    const { subject, body } = this.referralService.getSharingEmailInfo(this.merchant, this.advocate_info)
    this.model.subject = subject
    this.model.message = body
  }

  sendInvite(emailForm: NgForm) {
    this.is_submitted = true

    if (emailForm.valid) {
      this.error = null

      const invite = {
        emails: this.model.email.replace(/\s/g, "").split(","),
        subject: this.model.subject,
        message: this.model.message
      }

      this.referralService.sendInvite(this.merchant.id, this.advocate_info.referrer_code, invite).then(
        (response) => {
          const modalClosedSubscription = this.mdDialogRef.afterClosed().subscribe(() => {
            this.mdDialog.open(ReferralMagicSuccessModalComponent, {
              data: {
                advocate_info: this.advocate_info,
                advocate_url: this.advocate_url,
                advocate_identifier: this.advocate_identifier,
                colors: this.colors,
                merchant: this.merchant,
                referralService: this.referralService,
                qualification: this.qualification,
                is_embedded: this.is_embedded
              }
            })
            modalClosedSubscription.unsubscribe()
          })
          this.mdDialogRef.close(true)
        },
        (error) => {
          this.error = error.message
        }
      )
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/referral-magic/merchant-advocate/email-modal/email-modal.component.ts